import { DateTime } from "luxon"

/**
 * Returns a human-readable relative time string
 * @param dt - The DateTime to compare
 * @param now - The reference time to compare against (defaults to current time)
 * @returns Relative time string like "2 hours ago" or "in 3 days"
 */
const timeAgo = (dt: DateTime, now: DateTime = DateTime.now()) => {
  if (!dt.isValid) return '-'
  const units:Intl.RelativeTimeFormatUnit[] = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second']
  const diff = dt.diff(now).shiftTo(...units)
  const unit = units.find((unit) => diff.get(unit) !== 0) || 'second'
  // TODO handle other languages?
  const relativeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto', })
  return relativeFormatter.format(Math.trunc(diff.as(unit)), unit)
}

export default timeAgo